import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3d9e4838 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _6c4d4652 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2fd08e10 = () => interopDefault(import('../../../pages/app/bewertung/index.vue' /* webpackChunkName: "pages/app/bewertung/index" */))
const _39e43d62 = () => interopDefault(import('../../../pages/app/einstellungen.vue' /* webpackChunkName: "pages/app/einstellungen" */))
const _49d9899d = () => interopDefault(import('../../../pages/app/evaluation/index.vue' /* webpackChunkName: "pages/app/evaluation/index" */))
const _63ad0317 = () => interopDefault(import('../../../pages/app/forgot-password.vue' /* webpackChunkName: "pages/app/forgot-password" */))
const _664fa4cc = () => interopDefault(import('../../../pages/app/haftungsausschluss.vue' /* webpackChunkName: "pages/app/haftungsausschluss" */))
const _031b63e9 = () => interopDefault(import('../../../pages/app/liveparser.vue' /* webpackChunkName: "pages/app/liveparser" */))
const _3977d8ce = () => interopDefault(import('../../../pages/app/loading.vue' /* webpackChunkName: "pages/app/loading" */))
const _aa4f020a = () => interopDefault(import('../../../pages/app/login.vue' /* webpackChunkName: "pages/app/login" */))
const _b0c8845e = () => interopDefault(import('../../../pages/app/objekt-radar/index.vue' /* webpackChunkName: "pages/app/objekt-radar/index" */))
const _65cc368e = () => interopDefault(import('../../../pages/app/objekt-radar-evaluation/index.vue' /* webpackChunkName: "pages/app/objekt-radar-evaluation/index" */))
const _3f839b5d = () => interopDefault(import('../../../pages/app/portfolio/index.vue' /* webpackChunkName: "pages/app/portfolio/index" */))
const _3314bc16 = () => interopDefault(import('../../../pages/app/reset-rassword.vue' /* webpackChunkName: "pages/app/reset-rassword" */))
const _f0224070 = () => interopDefault(import('../../../pages/app/verification-email.vue' /* webpackChunkName: "pages/app/verification-email" */))
const _e465bb34 = () => interopDefault(import('../../../pages/app/objekt-radar/abonnement.vue' /* webpackChunkName: "pages/app/objekt-radar/abonnement" */))
const _b543dcfe = () => interopDefault(import('../../../pages/app/objekt-radar/details.vue' /* webpackChunkName: "pages/app/objekt-radar/details" */))
const _569dce9e = () => interopDefault(import('../../../pages/app/objekt-radar/subscription-done.vue' /* webpackChunkName: "pages/app/objekt-radar/subscription-done" */))
const _06a712bd = () => interopDefault(import('../../../pages/app/objekt-radar/testzeitraum_abgelaufen.vue' /* webpackChunkName: "pages/app/objekt-radar/testzeitraum_abgelaufen" */))
const _4a945a77 = () => interopDefault(import('../../../pages/app/objekt-radar/testzeitraum_aktivieren.vue' /* webpackChunkName: "pages/app/objekt-radar/testzeitraum_aktivieren" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/app",
    component: _3d9e4838,
    name: "app___default"
  }, {
    path: "/at",
    component: _6c4d4652,
    name: "index___at"
  }, {
    path: "/app/bewertung",
    component: _2fd08e10,
    name: "app-bewertung___default"
  }, {
    path: "/app/einstellungen",
    component: _39e43d62,
    name: "app-einstellungen___default"
  }, {
    path: "/app/evaluation",
    component: _49d9899d,
    name: "app-evaluation___default"
  }, {
    path: "/app/forgot-password",
    component: _63ad0317,
    name: "app-forgot-password___default"
  }, {
    path: "/app/haftungsausschluss",
    component: _664fa4cc,
    name: "app-haftungsausschluss___default"
  }, {
    path: "/app/liveparser",
    component: _031b63e9,
    name: "app-liveparser___default"
  }, {
    path: "/app/loading",
    component: _3977d8ce,
    name: "app-loading___default"
  }, {
    path: "/app/login",
    component: _aa4f020a,
    name: "app-login___default"
  }, {
    path: "/app/objekt-radar",
    component: _b0c8845e,
    name: "app-objekt-radar___default"
  }, {
    path: "/app/objekt-radar-evaluation",
    component: _65cc368e,
    name: "app-objekt-radar-evaluation___default"
  }, {
    path: "/app/portfolio",
    component: _3f839b5d,
    name: "app-portfolio___default"
  }, {
    path: "/app/reset-rassword",
    component: _3314bc16,
    name: "app-reset-rassword___default"
  }, {
    path: "/app/verification-email",
    component: _f0224070,
    name: "app-verification-email___default"
  }, {
    path: "/at/app",
    component: _3d9e4838,
    name: "app___at"
  }, {
    path: "/app/objekt-radar/abonnement",
    component: _e465bb34,
    name: "app-objekt-radar-abonnement___default"
  }, {
    path: "/app/objekt-radar/details",
    component: _b543dcfe,
    name: "app-objekt-radar-details___default"
  }, {
    path: "/app/objekt-radar/subscription-done",
    component: _569dce9e,
    name: "app-objekt-radar-subscription-done___default"
  }, {
    path: "/app/objekt-radar/testzeitraum_abgelaufen",
    component: _06a712bd,
    name: "app-objekt-radar-testzeitraum_abgelaufen___default"
  }, {
    path: "/app/objekt-radar/testzeitraum_aktivieren",
    component: _4a945a77,
    name: "app-objekt-radar-testzeitraum_aktivieren___default"
  }, {
    path: "/at/app/bewertung",
    component: _2fd08e10,
    name: "app-bewertung___at"
  }, {
    path: "/at/app/einstellungen",
    component: _39e43d62,
    name: "app-einstellungen___at"
  }, {
    path: "/at/app/evaluation",
    component: _49d9899d,
    name: "app-evaluation___at"
  }, {
    path: "/at/app/forgot-password",
    component: _63ad0317,
    name: "app-forgot-password___at"
  }, {
    path: "/at/app/haftungsausschluss",
    component: _664fa4cc,
    name: "app-haftungsausschluss___at"
  }, {
    path: "/at/app/liveparser",
    component: _031b63e9,
    name: "app-liveparser___at"
  }, {
    path: "/at/app/loading",
    component: _3977d8ce,
    name: "app-loading___at"
  }, {
    path: "/at/app/login",
    component: _aa4f020a,
    name: "app-login___at"
  }, {
    path: "/at/app/objekt-radar",
    component: _b0c8845e,
    name: "app-objekt-radar___at"
  }, {
    path: "/at/app/objekt-radar-evaluation",
    component: _65cc368e,
    name: "app-objekt-radar-evaluation___at"
  }, {
    path: "/at/app/portfolio",
    component: _3f839b5d,
    name: "app-portfolio___at"
  }, {
    path: "/at/app/reset-rassword",
    component: _3314bc16,
    name: "app-reset-rassword___at"
  }, {
    path: "/at/app/verification-email",
    component: _f0224070,
    name: "app-verification-email___at"
  }, {
    path: "/at/app/objekt-radar/abonnement",
    component: _e465bb34,
    name: "app-objekt-radar-abonnement___at"
  }, {
    path: "/at/app/objekt-radar/details",
    component: _b543dcfe,
    name: "app-objekt-radar-details___at"
  }, {
    path: "/at/app/objekt-radar/subscription-done",
    component: _569dce9e,
    name: "app-objekt-radar-subscription-done___at"
  }, {
    path: "/at/app/objekt-radar/testzeitraum_abgelaufen",
    component: _06a712bd,
    name: "app-objekt-radar-testzeitraum_abgelaufen___at"
  }, {
    path: "/at/app/objekt-radar/testzeitraum_aktivieren",
    component: _4a945a77,
    name: "app-objekt-radar-testzeitraum_aktivieren___at"
  }, {
    path: "/",
    component: _6c4d4652,
    name: "index___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
